import { createReducer, on } from '@ngrx/store';

import { UserSettingsEntityActions } from './user-settings-entity.actions';
import { UserSettingsEntityState, initialState } from './user-settings-entity.state';

export const reducer = createReducer(
  initialState,
  on(UserSettingsEntityActions.get_entity_start, UserSettingsEntityActions.update_entity_start, (state: UserSettingsEntityState) => ({
    ...state,
    error: null,
    userSettingsEntityLoading: true
  })),
  on(UserSettingsEntityActions.get_entity_success, UserSettingsEntityActions.update_entity_success, (state, data) => {
    return {
      ...state,
      userSettingsEntity: data.entity,
      error: null,
      userSettingsEntityLoading: false
    };
  }),
  on(UserSettingsEntityActions.get_entity_fail, (state, error) => ({
    ...state,
    userSettingsEntity: null,
    error,
    userSettingsEntityLoading: false
  }))
);
